import Common                                         from '../modules/common';
import {apiClientWithUserToken as apiClient, apiList} from '../modules/apiClient';
import moment                                         from 'moment';

const DownloadPdfsMixin = {
  data   : () => ({
    downloading     : false,
    downloadProgress: null,
    selectedPdfs    : [],
  }),
  methods: {
    downloadPdfs() {
      const self            = this;
      self.downloading      = true;
      self.downloadProgress = Common.messages.pdf.creatingZipFile;
      return new Promise((resolve, reject) => {
        apiClient
          .request({
            url               : apiList.jon.downloadPdfs,
            method            : 'post',
            responseType      : 'arraybuffer',
            data              : {
              registries: self.selectedPdfs.filter(Boolean),
            },
            onDownloadProgress: progressEvent => {
              self.downloadProgress = Math.floor(progressEvent.loaded / progressEvent.total * 100) + '%';
            },
          })
          .then(response => {
            self.downloading = false;
            if (response.data) {
              const blob = new Blob([response.data], {type: 'application/zip'})
              saveAs(blob, '登記情報_' + moment().format(Common.momentConst.suffixFormat) + '.zip');
              return resolve(true);
            } else {
              self.errorMessages = [Common.messages.pdf.downloadError];
              return resolve(false);
            }
          })
          .catch(error => {
            self.downloading   = false;
            self.errorMessages = [Common.messages.pdf.downloadError];
            return reject(error);
          });
      });
    },
    limitErrorMessage() {
      return Common.messages.pdf.limitError.replace(':limit', Common.downloadPdfLimit);
    },
  },
};

export default DownloadPdfsMixin;
